import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Dispatch, bindActionCreators } from 'redux';
import slugify from 'slugify';
import { TextField, MessageBar, MessageBarType, PrimaryButton, Label } from 'office-ui-fabric-react';
import 'react-sortable-tree/style.css';
import * as _yup from "yup";

import { MetaTypeEnum } from 'app/shared';
import { RootState } from "app/redux/reducer";
import { setPageData, setPageErrors, initialPageData } from 'app/redux/page/actions';
import { toggleModal } from 'app/redux/modal/actions';

import PageTitle from 'components/customs/PageTitle';
import { castThunkAction } from 'app/utils/casting';
import { createPlace, IPlace } from 'app/services/place';
import Sidebar from 'components/customs/Sidebar/Sidebar';
import PageLayout from 'containers/PageLayout';
import FormAccordion from 'components/customs/FormAccordion';
import MetaEditor from 'components/customs/MetaFields/Fields/MetaEditor';
import MetaSingleFile from 'components/customs/MetaFields/Fields/MetaSingleFile';

function mapStateToProps(state: RootState, ownProps: RouteComponentProps) {
    return {
        ...ownProps,
        defaultLanguage: state.system.defaultLanguage,
        language: state.system.language,
        pageData: state.page.pageData as IPlace,
        pageErrors: state.page.pageErrors,
        contentTypes: state.contentType.contentTypes.list
    }
}

function mapDispatchToProps(dispatch: Dispatch) {
    return {
        ...bindActionCreators({
            setPageData,
            setPageErrors,
            initialPageData,
            createPlace,
            toggleModal
        }, dispatch)
    };
}

type CreatePlaceProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

interface OwnState {
    messageType: MessageBarType;
}

class CreatePlace extends React.Component<CreatePlaceProps, OwnState> {

    state = {
        messageType: MessageBarType.warning,
    }

    componentDidMount() {
        this.resetData();
    }

    resetData() {
        this.setState({
            messageType: MessageBarType.warning
        }, () => {
            this.props.initialPageData<IPlace>({
                key: "",
                title: "",
                eventDetailTitle: "",
                description: "",
                content: "",
                order: 30,
                language: this.props.defaultLanguage,
                relationId: "",
            })
        })
    }

    renderTextByMessageType() {
        switch (this.state.messageType) {
            case MessageBarType.success:
                return "Kaydetme işlemi başarıyla gerçekleşmiştir. Düzenleme sayfasına yönlendiriliyorsunuz..."
            case MessageBarType.error:
                return "Kayıt işlemi yapılırken bir hata oluşmuştur. Lütfen servis sağlayıcınızla iletişime geçin."
            default:
                return null;
        }
    }

    renderMessageBar() {
        if (this.state.messageType !== MessageBarType.warning)
            return (
                <MessageBar
                    messageBarType={this.state.messageType}
                    isMultiline={false}
                >
                    {this.renderTextByMessageType()}
                </MessageBar>
            )
        return null;
    }

    /**
     * Validation Şemasını Kontrol Ederek, Eğer Validate ise Doğrulama modalını aktive eder, Değilse İlgili Yerlere Hata Dönecek Yani,
     * formErrors Objesini Dolduracak Action'u Tetikler.
     */
    onSubmit() {
        const {
            pageData,
            setPageErrors
        } = this.props;
        const validationSchema = _yup.object({
            title: _yup.string().required(
                "Bu alan zorunludur!"
            )
        });
        let formErrors = {};
        validationSchema
            .validate(pageData, {
                abortEarly: false
            })
            .then(() => {
                setPageErrors({});
                castThunkAction<IPlace>(this.props.createPlace(this.props.pageData)).then(res => {
                    this.setState({
                        messageType: res?.id ? MessageBarType.success : MessageBarType.error
                    }, () => {
                        if (res?.id) {
                            setTimeout(() => {
                                this.props.history.push(`/place/edit/${res.id}`)
                            }, 1200)
                        }
                    })

                })
            })
            .catch(err => {
                err.inner.forEach((e: any) => {
                    const { path, message } = e;
                    formErrors[path] = message;
                });
                setPageErrors(formErrors);
            });
    };


    renderForm() {
        return (
            <div className="form-groups row">
                <div className="form-group col-md-12">
                    <FormAccordion showContent={true} title="Genel Bilgiler">
                        <div className="form-wrapper row" style={{ padding: "10px 5px" }}>
                            <div className="item row col-md-4">
                                <TextField
                                    className="custom-textfield"
                                    label="Mekan Adı"
                                    value={this.props.pageData.title}
                                    onChange={(event: any) => {
                                        this.props.initialPageData({
                                            ...this.props.pageData,
                                            title: event.target.value,
                                            key: slugify(event.target.value, { lower: true, replacement: '-', strict: true })
                                        })
                                    }}
                                />
                            </div>
                            <div className="item row col-md-4">
                                <TextField
                                    className="custom-textfield"
                                    label="Mekan Etkinlik Detay Başlığı"
                                    value={this.props.pageData.eventDetailTitle}
                                    onChange={(event: any) => this.props.setPageData("eventDetailTitle", event.target.value)}
                                />
                            </div>
                            <div className="item row col-md-4">
                                <TextField
                                    className="custom-textfield"
                                    label="Mekan Anahtarı"
                                    value={this.props.pageData.key}
                                    disabled
                                />
                            </div>
                            <div className="item row col-md-12">
                                <TextField
                                    className="custom-textfield"
                                    label="Mekan Açıklaması"
                                    value={this.props.pageData.description}
                                    onChange={(event: any) => {
                                        this.props.setPageData("description", event.target.value)
                                    }}
                                    multiline={true}
                                    resizable={false}
                                />
                            </div>
                            <div className="item row col-md-12">
                                <Label>Mekan İçeriği</Label>
                                <MetaEditor
                                    type={MetaTypeEnum.Editor}
                                    onChange={(value: string) => {
                                        this.props.setPageData("content", value)
                                    }}
                                    meta={{ data: this.props.pageData.content, type: MetaTypeEnum.Editor, title: '', column: 12, name: '' }}
                                    toggleModal={toggleModal}
                                />
                            </div>
                        </div>
                    </FormAccordion>
                </div>
            </div>
        )
    }

    renderImages() {
        return (
            <div className="form-groups row">
                <div className="form-group col-md-12" style={{ paddingTop: 0 }}>
                    <FormAccordion showContent={true} title="Görsel Ayarları">
                        <div className="form-wrapper row" style={{ padding: "10px 5px" }}>
                            <div className="item row col-md-12">
                                <Label>Ana (Hero) Görsel</Label>
                                <MetaSingleFile
                                    type={MetaTypeEnum.SingleImage}
                                    onChange={(value) => {
                                        this.props.setPageData("profileImageHero", value)
                                    }}
                                    meta={{ data: this.props.pageData.profileImageHero, type: MetaTypeEnum.SingleImage, title: '', column: 12, name: '' }}
                                    toggleModal={toggleModal}
                                />
                            </div>
                            <div className="item row col-md-12">
                                <Label>Yatay Görsel</Label>
                                <MetaSingleFile
                                    type={MetaTypeEnum.SingleImage}
                                    onChange={(value) => {
                                        this.props.setPageData("profileImageHorizontal", value)
                                    }}
                                    meta={{ data: this.props.pageData.profileImageHorizontal, type: MetaTypeEnum.SingleImage, title: '', column: 12, name: '' }}
                                    toggleModal={toggleModal}
                                />
                            </div>
                            <div className="item row col-md-12">
                                <Label>Dikey Görsel</Label>
                                <MetaSingleFile
                                    type={MetaTypeEnum.SingleImage}
                                    onChange={(value) => {
                                        this.props.setPageData("profileImageVertical", value)
                                    }}
                                    meta={{ data: this.props.pageData.profileImageVertical, type: MetaTypeEnum.SingleImage, title: '', column: 12, name: '' }}
                                    toggleModal={toggleModal}
                                />
                            </div>
                            <div className="item row col-md-12">
                                <Label>Mekan SVG</Label>
                                <MetaSingleFile
                                    type={MetaTypeEnum.SingleImage}
                                    onChange={(value) => {
                                        this.props.setPageData("placeSvg", value)
                                    }}
                                    meta={{ data: this.props.pageData.placeSvg, type: MetaTypeEnum.SingleImage, title: '', column: 12, name: '' }}
                                    toggleModal={toggleModal}
                                />
                            </div>
                        </div>
                    </FormAccordion>
                </div>
            </div>
        )
    }

    render() {
        return (
            <PageLayout history={this.props.history} match={this.props.match} location={this.props.location}>
                <div className="page push-all">
                    <PageTitle
                        title="Yeni Mekan Ekle"
                        titleRenderer={
                            () => (
                                <span className="edit-title">
                                    Yönet:
                                    <strong>Yeni Mekan Ekle</strong>
                                </span>
                            )
                        }
                        showBack
                        backUrl="/places"
                        history={this.props.history}
                        subTitle="Yeni bir mekan eklemek için aşağıdaki bilgileri doldurunuz, dilerseniz taslak olarakta oluşturabilirsiniz."
                    />
                    <PrimaryButton
                        onClick={() => { this.resetData() }}
                        iconProps={{ iconName: "Add" }}
                        className="absolute-create"
                        text="Yeni Mekan Ekle"
                        styles={{
                            root: {
                                background: "#62a98e",
                                borderColor: "#5b9e85",
                                color: "#fff"
                            },
                            rootHovered: {
                                background: "#5b9e85",
                                borderColor: "#5b9e85"
                            },
                            rootDisabled: {
                                background: "#ececec"
                            }
                        }}
                    />
                    <div className="content row">
                        <div className="left col no-padding">
                            {this.renderMessageBar()}
                            {this.renderForm()}
                        </div>
                        <Sidebar
                            categoryBar={{
                                hide: true
                            }}
                            publishBar={{
                                onSave: () => this.onSubmit(),
                                disabledSaveButton: this.state.messageType === MessageBarType.success ? true : false,
                                hideDeleteButton: true,
                                hideDraftButton: true,
                                hidePreviewButton: true,
                                showOrder: true,
                                order: this.props.pageData?.order || 0,
                                onChangeOrderIndex: (order) => this.props.setPageData("order", order),
                            }}
                            layoutBar={{
                                hide: true
                            }}
                            archiveBar={{
                                hide: true
                            }}
                            thumbnailBar={{
                                hide: true
                            }}
                        >
                            {this.renderImages()}
                        </Sidebar>
                    </div>
                </div>
            </PageLayout>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreatePlace);